module.exports = __webpack_public_path__ + "img/main_13.42b06283.jpg";